import React from "react";
import wp from "../../Assets/Whatsapp.png";
import ins from "../../Assets/Insta.png";
import gm from "../../Assets/Gmaps.png";
export default function Footer() {
  return (
    <div className="bg-[#000000] text-white py-8 z-50 w-full">
      <h1 className="text-[32px] font-bold text-center py-8">Contact Us</h1>
      <div className="container mx-auto px-4 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Wakad */}
        <div className="flex flex-col gap-8 items-center w-full pt-2">
          <div>
            <h4 className="text-lg font-bold mb-4">Wakad</h4>
          </div>
          <div className="flex space-x-4 justify-around w-[100%] px-8">
            <a
              href="https://api.whatsapp.com/send?phone=+918408842494"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={wp} alt="whatsapps" className="h-[40px] w-[40px]" />
            </a>

            <a
              href="https://www.instagram.com/spinjoy_/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ins} alt="Instagram" className="h-[40px] w-[40px]" />
            </a>

            <a
              href="https://maps.app.goo.gl/NsEU9SAuUiTAbgz39"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={gm} alt="GMaps" className="h-[40px] w-[40px]" />
            </a>
          </div>
          <div className="text-lg font-bold mb-4 text-center">
            <h1>Phone No.</h1>
            <a href="tel:+919044455050">+91 8408842494</a>
          </div>
        </div>
        {/* Shinde Vasti,Hinjawadi */}
        <div className="flex flex-col gap-8 items-center w-full pt-2">
          <div>
            <h4 className="text-lg font-bold mb-4">Shinde Vasti,Hinjawadi </h4>
          </div>
          <div className="flex space-x-4 justify-around w-[100%] px-8">
            <a
              href="https://api.whatsapp.com/send?phone=7387804606"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={wp} alt="whatsapps" className="h-[40px] w-[40px]" />
            </a>

            <a
              href="https://www.instagram.com/spinjoy03/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ins} alt="Instagram" className="h-[40px] w-[40px]" />
            </a>

            <a
              href="https://maps.app.goo.gl/zYbcdUZsbdkVaGYMA"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={gm} alt="GMaps" className="h-[40px] w-[40px]" />
            </a>
          </div>
          <div className="text-lg font-bold mb-4 text-center">
            <h1>Phone No.</h1>

            <a href="tel:+917387804606">+91 7387804606</a>
          </div>
        </div>
        {/* Sakhare Vasti (Blue Ridge),Hinjawadi */}
        <div className="flex flex-col gap-8 items-center w-full pt-2">
          <div>
            <h4 className="text-lg font-bold mb-4">
              Sakhare Vasti (Blue Ridge),Hinjawadi
            </h4>
          </div>
          <div className="flex space-x-4 justify-around w-[100%] px-8">
            <a
              href="https://api.whatsapp.com/send?phone=9044455050"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={wp} alt="whatsapps" className="h-[40px] w-[40px]" />
            </a>

            <a
              href="https://www.instagram.com/spinjoy04/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ins} alt="Instagram" className="h-[40px] w-[40px]" />
            </a>

            <a
              href="https://maps.app.goo.gl/E1hH4sES8vPqqmnN6"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={gm} alt="GMaps" className="h-[40px] w-[40px]" />
            </a>
          </div>
          <div className="text-lg font-bold mb-4 text-center">
            <h1>Phone No.</h1>
            <a href="tel:+919044455050">+91 9044455050</a>
          </div>
        </div>
        {/* Mukainagar Near Mezza 9*/}
        <div className="flex flex-col gap-8 items-center w-full pt-2">
          <div>
            <h4 className="text-lg font-bold mb-4">Mukainagar Near Mezza 9</h4>
          </div>
          <div className="flex space-x-4 justify-around w-[100%] px-8">
            <a
              href="https://api.whatsapp.com/send?phone=7066455050"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={wp} alt="whatsapps" className="h-[40px] w-[40px]" />
            </a>

            <a
              href="https://www.instagram.com/spinjoy04/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={ins} alt="Instagram" className="h-[40px] w-[40px]" />
            </a>

            <a
              href="https://maps.app.goo.gl/e81gNcctKMaioZfg8"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={gm} alt="GMaps" className="h-[40px] w-[40px]" />
            </a>
          </div>
          <div className="text-lg font-bold mb-4 text-center">
            <h1>Phone No.</h1>
            <a href="tel:+917066455050">+91 7066455050</a>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-200 mt-8 pt-4 text-center text-sm">
        <p>© 2024 SpiNjoy Laundromat. All rights reserved.</p>
        <p className="mt-4 text-[10px]">
          Made with love and gratitude for a special friend! By
          <a
            href="https://www.instagram.com/aura_wx.studio?igsh=MWwxaTc5aWRxMzR0cQ=="
            target="_blank"
            style={{ color: "#0fbfe6" }}
          >
            "AURA_WX.Studio"
          </a>
        </p>
      </div>
    </div>
  );
}
